import React, { useEffect, useRef, useState } from 'react';
import { useAnimatedNumber } from '../calculator/useAnimatedNumber';

const useInView = () => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setInView(true); io.disconnect(); } }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return [ref, inView];
};

export const Reveal = ({ as: Tag = 'div', delay = 0, className = '', children, ...rest }) => {
  const [ref, inView] = useInView();
  return (
    <Tag ref={ref} className={`rv ${inView ? 'in' : ''} ${className}`} style={{ transitionDelay: `${delay}ms` }} {...rest}>
      {children}
    </Tag>
  );
};

// Counts from 0 to `to` once scrolled into view
export const CountUp = ({ to, duration = 1400, className = '' }) => {
  const [ref, inView] = useInView();
  const v = useAnimatedNumber(inView ? to : 0, duration);
  return <span ref={ref} className={className}>{Math.round(v)}</span>;
};

// Splits text into words that rise in one after another; `parts` = [[text, className], ...]
export const Words = ({ as: Tag = 'h2', parts, className = '', step = 60, ...rest }) => {
  const [ref, inView] = useInView();
  let i = 0;
  return (
    <Tag ref={ref} className={`wr ${inView ? 'in' : ''} ${className}`} {...rest}>
      {parts.map(([text, cls], p) => text.split(/(\s+)/).map((w, k) => (
        /^\s+$/.test(w) ? w : <span key={`${p}-${k}`} className={`wr-word ${cls || ''}`} style={{ transitionDelay: `${(i++) * step}ms` }}>{w}</span>
      )))}
    </Tag>
  );
};
